import { Button } from "antd";
import { useMsal } from "@azure/msal-react";

export default function NotRegistered() {
  const { instance } = useMsal();

  const handleBackToLogin = () => {
    instance.logoutRedirect();
  };

  return (
    <div style={{ textAlign: "center", marginTop: "5rem" }}>
      <h1>Account Not Registered</h1>
      <p>Your email is not associated with any employee in the system.</p>
      <p>Please contact the administrator.</p>

      <Button
        type="primary"
        onClick={handleBackToLogin}
        style={{ marginTop: "1.5rem" }}
      >
        Back to Login
      </Button>
    </div>
  );
}
